import React from 'react';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Box } from '@tmap/mmm-style-guide/src/Box';

function BlankPreview() {
  return (
    <Box display='flex' alignItems='center' justifyContent='center' width='100%' minHeight='120px' sx={{ background: (t) => t.palette.inverted.contrastText, width: '100%' }}>
      <Typography variant='h3' fontWeight={600} color='textSecondary' textAlign='center'>
        No Preview Available
      </Typography>
    </Box>
  );
}

export default BlankPreview;
